import React from 'react';
import { Router } from 'react-router';
import { useSelector } from 'react-redux';
import { Redirect, Route, Switch } from 'react-router-dom';
import { History } from 'history';
import { LinearProgress } from '@material-ui/core';

import { appInitStatusSelector } from 'state/app/selectors';
import { AppInitStatus } from 'state/app/reducer';
import { StoreState } from 'state/store/reducer';

import { ErrorBoundary } from 'components/ErrorBoundary';
import { GuestRoute } from 'components/GuestRoute/GuestRoute';
import { VendorRoute } from 'components/VendorRoute/VendorRoute';
import { VendorRegistrationRoute } from 'components/VendorRegistrationRoute/VendorRegistrationRoute';

import { InitError } from 'InitError';

import { Legal } from 'pages/Legal/Legal';
import { Login } from 'pages/Login/Login';
import { Onboarding } from 'pages/Onboarding/Onboarding';
import { ResetPassword } from 'pages/ResetPassword/ResetPassword';
import { Signup } from 'pages/Signup/Signup';
import { Vendor } from 'pages/Vendor/Vendor';

import { RoutePath } from 'RoutePath';
import { Buyers } from 'pages/Buyers/Buyers';
import { Contacts } from 'pages/Contacts/Contacts';
import { Sellers } from 'pages/Sellers/Sellers';
import { Delivery } from 'pages/Delivery/Delivery';
import { Payments } from 'pages/Payments/Payments';
import { MenuContainer } from 'MenuContainer';
import { BlogPage } from 'pages/Blog/BlogPage';
import { FakeStoreRegistration } from 'pages/Onboarding/FakeStoreRegistration';
import { Selling } from 'pages/Selling/Selling';
import { CheckoutCartDialog } from 'pages/Checkout/CheckoutCartDialog';

import { Report } from 'pages/AdminReport/Report';

const redirectForOldStoreUrls = [
    RoutePath.STORE,
    RoutePath.STORE_INFO,
    RoutePath.STORE_PRODUCT,
    RoutePath.STORE_PRODUCT_CHECKOUT,
];

export interface RouteProps {
    history: History;
    store?: StoreState;
    storeSlug?: string;
}

export const Routes = ({ history }: RouteProps) => {
    const appInitStatus = useSelector(appInitStatusSelector);
    // if (appInitStatus === AppInitStatus.PENDING) {
    //     return <LinearProgress />;
    // }
    if (appInitStatus === AppInitStatus.FAILURE) {
        return <InitError />;
    }
    return (
        <Router history={history}>
            <CheckoutCartDialog />
            <MenuContainer isSsr={false} />
            <Switch>
                <Route path={RoutePath.SELLING}>
                    <Selling />
                </Route>
                <GuestRoute exact={true} path={RoutePath.BUYERS}>
                    <ErrorBoundary>
                        <Buyers />
                    </ErrorBoundary>
                </GuestRoute>
                <GuestRoute exact={true} path={RoutePath.SELLERS}>
                    <ErrorBoundary>
                        <Sellers />
                    </ErrorBoundary>
                </GuestRoute>
                <GuestRoute exact={true} path={RoutePath.DELIVERY}>
                    <ErrorBoundary>
                        <Delivery />
                    </ErrorBoundary>
                </GuestRoute>
                <GuestRoute exact={true} path={RoutePath.PAYMENTS}>
                    <ErrorBoundary>
                        <Payments />
                    </ErrorBoundary>
                </GuestRoute>
                <GuestRoute exact={true} path={RoutePath.CONTACTS}>
                    <ErrorBoundary>
                        <Contacts />
                    </ErrorBoundary>
                </GuestRoute>
                <GuestRoute exact={true} path={RoutePath.BLOGPAGE}>
                    <ErrorBoundary>
                        <BlogPage />
                    </ErrorBoundary>
                </GuestRoute>
                <GuestRoute exact={true} path={RoutePath.LOGIN}>
                    <ErrorBoundary>
                        <Login />
                    </ErrorBoundary>
                </GuestRoute>
                <Route exact={true} path={RoutePath.SIGNUP}>
                    <ErrorBoundary>
                        <Signup />
                    </ErrorBoundary>
                </Route>
                <Route exact={true} path={RoutePath.RESET_PASSWORD}>
                    <ErrorBoundary>
                        <ResetPassword />
                    </ErrorBoundary>
                </Route>
                <VendorRegistrationRoute exact={true} path={RoutePath.REGISTRATION_FAKE}>
                    <ErrorBoundary>
                        <FakeStoreRegistration />
                    </ErrorBoundary>
                </VendorRegistrationRoute>
                <VendorRegistrationRoute path={RoutePath.REGISTRATION}>
                    <ErrorBoundary>
                        <Onboarding />
                    </ErrorBoundary>
                </VendorRegistrationRoute>
                <VendorRoute path={RoutePath.VENDOR}>
                    <ErrorBoundary>
                        <Vendor />
                    </ErrorBoundary>
                </VendorRoute>
                <Route path={RoutePath.LEGAL}>
                    <ErrorBoundary>
                        <Legal />
                    </ErrorBoundary>
                </Route>
                <Route exact={true} path={RoutePath.ADMIN_REPORT}>
                    <ErrorBoundary>
                        <Report />
                    </ErrorBoundary>
                </Route>

                {redirectForOldStoreUrls.map(url => (
                    <Redirect key={url} exact={true} from={'/store' + url} to={url} />
                ))}
                <Redirect to={RoutePath.FEED} />
            </Switch>
        </Router>
    );
};
